import{m as s}from"./chunk-HBP5N4FR.js";s();var e=t=>!/[^\x00-\x7F]/gm.test(t);export{e as a};
//# sourceMappingURL=chunk-OQ7P4SR6.js.map
